import type { ReactNode } from 'react';
import { useAuth } from '@/hooks/useAuth';
import type { Permission } from '@/types/rbac-auth.types';

/** anyOf: basta tener UNO de los permisos. */
export function useCan(permission: Permission | Permission[]): boolean {
  const { hasPermission } = useAuth();
  const perms = Array.isArray(permission) ? permission : [permission];
  return perms.some((p) => hasPermission(p));
}

export function Can({ permission, children, fallback = null }: {
  permission: Permission | Permission[]; children: ReactNode; fallback?: ReactNode;
}) {
  return <>{useCan(permission) ? children : fallback}</>;
}
